import { memo } from 'react';

const VimeoEmbed = memo(({ embedUrl }) => (
  <iframe
    title="vimeo-player"
    src={embedUrl}
    width="100%"
    height="360"
    frameBorder="0"
    allowFullScreen
    loading="lazy"
  ></iframe>
));

VimeoEmbed.displayName = 'VimeoEmbed';

export default VimeoEmbed;